import { render, staticRenderFns } from "./BlockType104.vue?vue&type=template&id=7a890b50&scoped=true"
import script from "./BlockType104.vue?vue&type=script&lang=ts"
export * from "./BlockType104.vue?vue&type=script&lang=ts"
import style0 from "./BlockType104.vue?vue&type=style&index=0&id=7a890b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a890b50",
  null
  
)

export default component.exports